// extracted by mini-css-extract-plugin
export default {"container":"Um-z","backNav":"Vm-z"};